import { Component, OnInit, Inject } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
  ValidatorFn,
  FormBuilder,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from "@angular/material";
import { UsersService } from "../../../users/users.service";
import { NgProgress } from "@ngx-progressbar/core";
import { GlobalServiceService } from "../../../services/global-service.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-change-pass",
  templateUrl: "./change-pass.component.html",
  styleUrls: ["./change-pass.component.scss"],
})
export class ChangePassComponent implements OnInit {
  passform: FormGroup;
  hidePassOld = true;
  hidePassNew = true;
  hidePassNewConfirm = true;
  flag_primer_inicio: any;
  infoUser: any;
  typeFlag: boolean = false;
  flagPeticion: boolean = true;
  constructor(
    public progress: NgProgress,
    public userService: UsersService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ChangePassComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public app: GlobalServiceService,
    private router: Router
  ) {

  }

  ngOnInit() {
    if (this.data) this.flag_primer_inicio = this.data.primer_inicio;
    this.infoUser = this.data.infoUser;
    this.typeFlag = this.data.typeFag;


    this.passform = new FormGroup(
      {
        pass_old: new FormControl("", [Validators.required]),
        pass_new: new FormControl("", [
          Validators.required,
          Validators.pattern(
            "(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])(?=.*[@_$]).{8,}"
          ),
        ]),
        pass_new_confirm: new FormControl("", [
          Validators.required,
          Validators.minLength(8),
        ]),
      },
      PasswordValidation.MatchPassword
    );
  }

  save() {
    if (this.flagPeticion) {
      this.flagPeticion= false;
      this.progress.start();
      this.infoUser.verifypassword = this.passform.value.pass_old.trim();
      this.infoUser.password = this.passform.value.pass_new.trim();
      this.userService
        .editUser(this.data.id, this.data.usuario_id, this.infoUser)
        .subscribe(
          (resChangePass: any) => {
             this.flagPeticion= true;
            if (resChangePass.success) {
              this.progress.complete();
              this.showMsg("Contraseña actualizada correctamente");
              this.dialogRef.close();


              localStorage.removeItem("userInfo");
              localStorage.removeItem("access");
              localStorage.removeItem("userInfoEncrypted");
              this.app.setLogged(false);
              this.router.navigate(["login"]);
              localStorage.clear();
            } else {
              this.progress.complete();
              this.showMsg(resChangePass.msg);
              // if (resChangePass.msg == "La Contraseña es incorrecta")
              //   this.showMsg(
              //     "Error, verifique que su contraseña anterior sea correcta"
              //   );
              // else this.showMsg(resChangePass.msg);
            }
          },
          (err) => {
            this.flagPeticion= true;
            console.log(err);
            this.progress.complete();
            this.showMsg(err.error.msg);
          }
        );
    }
  }

  changeViewPassNew() {
    this.hidePassNewConfirm = !this.hidePassNewConfirm;
  }

  showMsg(msg = "") {
    this.snackBar.open(msg, "Cerrar", {
      duration: 3000,
    });
  }
}

export class PasswordValidation {
  static MatchPassword(AC: AbstractControl) {
    let password = AC.get("pass_new").value; // to get value in input tag
    let confirmPassword = AC.get("pass_new_confirm").value; // to get value in input tag
    if (password != confirmPassword) {
      AC.get("pass_new_confirm").setErrors({ MatchPassword: true });
    } else {
      //console.warn('true');
      return null;
    }
  }
}
